import Home from './views/Home.jsx';
import { Route, Routes } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Login from './views/Login.jsx';
import { ProtectedRoute } from './ProtectedRoute';
import { NotFound } from './NotFound.jsx';
import { PlayerListView } from './views/PlayerListView.jsx';
import { RaidListView } from './views/RaidListView.jsx';
import { ItemAwardedListView } from './views/itemAwardedListView.jsx';
import { PlayerDetailView } from './views/PlayerDetailView.jsx';
import { RaidDetailView } from './views/RaidDetailView.jsx';
import { ApprovalPendingListView } from './views/ApprovalPendingListView.jsx';
import { ApprovalPendingDetailView } from './views/ApprovalPendingDetailView.jsx';
import { RaidEditView } from './views/RaidEditView.jsx';
import { ApprovalHistoryListView } from './views/ApprovalHistoryListView.jsx';
import { PlayerEditView } from './views/PlayerEditView.jsx';
import { Screenshots } from './views/Screenshots.jsx';
import { RosterView } from './views/RosterView.jsx';
import { CompareView } from './views/CompareView.jsx';
import { SQLQueryView } from './views/SQLQueryView.jsx';

function App() {
    const queryClient = new QueryClient();

    return (
        <>
            <QueryClientProvider client={queryClient}>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<Home />} />
                    <Route element={<ProtectedRoute needSuper={false} />}>
                        <Route path="/player" element={<PlayerListView />} />
                        <Route path="/raid" element={<RaidListView />} />
                        <Route path="/item_awarded" element={<ItemAwardedListView />} />
                        <Route path="/player/:id" element={<PlayerDetailView />} />
                        <Route path="/raid/:id" element={<RaidDetailView />} />
                        <Route path="/compare" element={<CompareView />} />
                        <Route path="/screenshots" element={<Screenshots />} />
                        <Route path="/roster" element={<RosterView />} />
                    </Route>

                    <Route element={<ProtectedRoute needSuper={true} />}>
                        <Route path="/ra_approval_pending" element={<ApprovalPendingListView />} />
                        <Route path="/ra_approval_history" element={<ApprovalHistoryListView />} />
                        <Route path="/ra_approval_pending/:id" element={<ApprovalPendingDetailView />} />
                        <Route path="/raid/:id/edit" element={<RaidEditView />} />
                        <Route path="/player/:id/edit" element={<PlayerEditView />} />
                        <Route path="/sql" element={<SQLQueryView />} />
                    </Route>

                    <Route path="*" element={<NotFound />} />
                </Routes>
            </QueryClientProvider>
        </>
    );
}

export default App;
